import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrls, apiHostUrl, unauth } from '../../shared/utils/globalConfig';
import { addHeaders } from '../../shared/utils/globalUtils';

export const devicesAndPlansApi = createApi({
    reducerPath: 'deviceselection',
    baseQuery: fetchBaseQuery({
        baseUrl: apiHostUrl,
        prepareHeaders: (headers) => {
            return addHeaders(headers, unauth);
        }
    }),
    endpoints: (builder) => ({
        getDevicesAndPlansByName: builder.query({
            query: (payload) => ({
                url: unauth ? apiUrls?.itpNsaPlansUrl_ua  : apiUrls?.itpNsaDevicesAndPlansUrl,
                method: 'POST',
                body: payload
            })
        }),
    }),

})

export const { useGetDevicesAndPlansByNameQuery } = devicesAndPlansApi;